import { hotelService } from "@/services/hotel-service";
import { useQuery } from "@tanstack/react-query";

export const bookingSourcesKeys = {
  all: ["bookingSources"] as const,
  lists: () => [...bookingSourcesKeys.all, "list"] as const,
  list: (hotelId?: string) => [...bookingSourcesKeys.lists(), hotelId] as const,
};

export const useBookingSources = (hotelId?: string) => {
  return useQuery({
    queryKey: bookingSourcesKeys.list(hotelId),
    queryFn: () => hotelService.getUniqueBookingSources(hotelId),
    enabled: !!hotelId,
  });
};
